import { Navigate } from "react-router-dom";
import {
  clearAuth,
  getStoredRole,
  hasValidSession,
  markSessionExpired,
} from "../services/authService";

const AdminRoute = ({ children }) => {
  const role = getStoredRole();

  if (!hasValidSession()) {
    clearAuth();
    markSessionExpired();
    return <Navigate to="/" replace />;
  }

  if (role !== "ADMIN") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;